/**
 * `/` — primary site landing. Redirects to `/performance`.
 *
 * The IA split on 2026-05-30 promoted Performance to the default
 * landing surface (the brand's reason-for-being); Traffic, Behaviours,
 * and Sales sit alongside it. `/` is kept as a redirect so historical
 * links and the SidebarOrgPill site-switch fallback (which navigates
 * to `/` after picking a new site) still land somewhere meaningful.
 *
 * Pure routing — no UI, no skeleton. The redirect fires in
 * `beforeLoad` so the Performance route's loader runs straight away
 * instead of through an interstitial render.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/')({
  beforeLoad: () => {
    throw redirect({ to: '/performance' });
  },
});
